import { render, staticRenderFns } from "./index.vue?vue&type=template&id=970c7ee8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=970c7ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c7ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('970c7ee8')) {
      api.createRecord('970c7ee8', component.options)
    } else {
      api.reload('970c7ee8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=970c7ee8&scoped=true&", function () {
      api.rerender('970c7ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5/custom/index.vue"
export default component.exports